<script lang="ts">
  import {userData, userSignedIn } from "../store";
  import { cancelPremium } from "../firebaseOperations";

  async function cancelPremiumSubscription(id: string) {
    if (!$userSignedIn) {
      return;
    }
    const response = await cancelPremium(id);
    if (response) {
      const cancelDiv = document.getElementById("cancelDiv");
      const cancelMessage = document.createElement("p");
      cancelMessage.textContent = "Subscription cancelled successfully";
      document.getElementById("premiumTitle").hidden = true;
      cancelDiv.appendChild(cancelMessage);
      setTimeout(() => {
        cancelMessage.remove();
      }, 5000);
    }
  }

 
</script>
<div class="border-bottom" />

<div class="privacy-policy">

  <p>
    Your data is never distributed to third parties. Contact <a href="https://aiobfuscation.com">Artificial Intelligence Obfuscation LLC</a> to learn more.
  </p>
  <a href="/privacypolicy.html">Privacy Policy</a> | <a href="/refundpolicy.html">Refund Policy</a> 
  <br>
  <p>V4.1.0</p>
  <button
        id="cancelSubscriptionButton"
        class:grey-overlay={!$userSignedIn}
        on:click={() => cancelPremiumSubscription($userData.id)}
        >Cancel TextCloaker Premium</button
      >
  <div id="cancelDiv">
  </div>
  
</div>

